/* Tessera front-end helpers.
   1. tessera-daily landing page: plan sync, sticky add-to-cart, cart drawer bridge.
   2. about-us page: points the "Join the movement" CTA at the account login.
      That button is hardcoded inside templates/page.contact-us.liquid (146KB),
      which the About us page renders via its "contact-us" template suffix.
      Patched here rather than rewriting that whole file. */

/* ---------- 2. About us: Join the movement -> account login ---------- */
(function () {
  function fixJoin() {
    var links = document.querySelectorAll('a.btn, a.nav-cta');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var txt = (a.textContent || '').trim().toLowerCase();
      var href = a.getAttribute('href') || '';
      if (txt === 'join the movement' && (href === '#' || href === '')) {
        a.setAttribute('href', '/account');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixJoin);
  } else {
    fixJoin();
  }
})();

/* ---------- 1. tessera-daily landing page ---------- */
(function () {
  /* Keep in sync with snippets/tlp-offer.liquid - the card markup and this table
     are two copies of the same prices. Basis: one serving per day.
       90: $63.00 / 90 servings = $0.70, quoted $21/mo
       30: standing rate $25.50 / 30 servings = $0.85. First 4 weeks bill $21.00,
           so the button still quotes $21/mo while the serving figure quotes the
           standing rate (Wander, 2026-08-13). Those two numbers deliberately
           describe different prices - see the note in tlp-offer.liquid.
     once: $30.00 / 30 servings = $1.00 */
  /* 2026-09-02 (Wander): the 30-Day button now quotes $25.50/mo, was $21/mo.
     This row and the card in snippets/tlp-offer.liquid were repriced together
     to the live Appstle selling plan (15% off the $30.00 variant = $25.50).
     serving stays $0.85 - it already quoted the standing rate, and
     $25.50 / 30 servings = $0.85 exactly, so button and serving finally agree.
     The paragraph above describes the OLD split where they deliberately did
     not; it is kept as history. The '90' row is untouched and still quotes
     $21/mo against $63.00 every 12 weeks, which no selling plan backs. */
  /* 2026-09-02 (Wander), later the same day: the "/mo" suffix came off the two
     button values - '90' was '$21/mo', '30' was '$25.50/mo'. 'once' never had
     one. This matches the plan cards, which lost their <span class="per">/mo,
     and the sticky bar's initial paint in snippets/tlp-offer.liquid. Every
     serving value and every qty is unchanged. */
  /* 2026-09-02 (Wander): `plan` is the Appstle selling plan each card sells,
     as the NUMERIC id /cart/add.js expects (not the gid). Verified against the
     Admin API the same day - both groups are attached to the product and
     resolve on variant 57159070351691 ($30.00):
       '90'   724415742283  "90 day supply"         30% off, bills every 3 MONTHS
       '30'   724393361739  "Monthly Subscription"  15% off, bills every 1 MONTH
       'once' null          plain one-time purchase at the variant price
     Until this landed NOTHING on the page attached a selling plan, so every
     add was a one-time line at $30.00 whatever the card promised. qty and the
     display strings are unchanged. */
  var PLANS = {
    '90':   { qty: 3, plan: 724415742283, btn: '$21', serving: '$0.70 / serving' },
    '30':   { qty: 1, plan: 724393361739, btn: '$25.50', serving: '$0.85 / serving' },
    'once': { qty: 1, plan: null,         btn: '$30.00', serving: '$1.00 / serving' }
  };

  var tlp, atc, sticky, sel, selWrap, priceEl, servingEl, stickyBtn, opener, buybox;
  var current = '90';

  function variantId() {
    var el = tlp && tlp.querySelector('[data-variant]');
    return el ? el.getAttribute('data-variant') : null;
  }

  function hasOption(plan) {
    if (!sel) { return false; }
    return !!sel.querySelector('option[value="' + plan + '"]');
  }

  function paint(plan) {
    var p = PLANS[plan];
    if (!p) { return; }
    current = plan;

    tlp.querySelectorAll('.plan[data-plan]').forEach(function (card) {
      if (card.getAttribute('data-plan') === plan) {
        card.classList.add('sel');
      } else {
        card.classList.remove('sel');
      }
    });

    if (selWrap) {
      if (hasOption(plan)) {
        selWrap.style.display = '';
        if (sel.value !== plan) { sel.value = plan; }
      } else {
        selWrap.style.display = 'none';
      }
    }

    if (priceEl) { priceEl.textContent = p.btn; }
    if (servingEl) { servingEl.textContent = p.serving; }
  }

  /* `done` replaces the default cart-drawer open. NO CALLER PASSES IT any more
     - the one-time link used it to navigate to /cart and stopped doing so on
     2026-09-02 (see the note where it is called). Kept as the escape hatch for
     any future add that must not open the drawer.
     `busy` guards a double click: the one-time link is an <a> with no disabled
     state, so without it a fast second click adds a second unit. */
  var busy = false;

  /* 2026-09-02 (Wander): takes the PLAN KEY, not a bare qty, so quantity and
     selling plan are read from the same PLANS row at the moment of the click
     and cannot drift apart. `selling_plan` goes on the item only when the row
     has one - it is never sent as null or "" (Shopify rejects those on some
     paths). The body used to be
         { items: [{ id, quantity: qty }] }
     with no selling_plan at all. */
  function addToCart(planKey, btn, done) {
    var p = PLANS[planKey];
    var id = variantId();
    if (!p || !id || busy) { return; }
    busy = true;
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    var item = { id: Number(id), quantity: p.qty };
    if (p.plan) { item.selling_plan = p.plan; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      if (!res.ok) { busy = false; return; }
      /* busy is deliberately left set on the `done` path: it exists for a
         caller that navigates away, where clearing it would reopen the
         double-add window during the redirect. Nothing passes `done` today,
         so every add now falls through to the two lines below - busy cleared,
         drawer opened. */
      if (done) { done(); return; }
      busy = false;
      if (opener) { opener.click(); }
    }).catch(function () {
      busy = false;
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    });
  }

  function onScroll() {
    if (!sticky || !buybox) { return; }
    var r = buybox.getBoundingClientRect();
    var past = r.bottom < 140;
    if (past) {
      sticky.classList.add('is-on');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-on');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function init() {
    tlp = document.getElementById('tlp');
    if (!tlp) { return; }

    atc       = document.getElementById('tlpAtc');
    sticky    = document.getElementById('tlpSticky');
    sel       = document.getElementById('tlpStickySelect');
    selWrap   = document.getElementById('tlpStickySelectWrap');
    priceEl   = document.getElementById('tlpStickyPrice');
    servingEl = document.getElementById('tlpStickyServing');
    stickyBtn = document.getElementById('tlpStickyBtn');
    opener    = document.getElementById('tcdOpener');
    buybox    = document.getElementById('offer');

    paint('90');

    tlp.addEventListener('click', function (e) {
      if (e.target.closest('.gifts')) { return; }

      var card = e.target.closest('.plan[data-plan]');
      if (card) { paint(card.getAttribute('data-plan')); return; }

      /* One Time Purchase. History:
           before 2026-08-30  a SELECTOR - it painted the 'once' plan and
                              updated the sticky bar, and bought nothing.
           2026-08-30         a buy action that added 1 unit and then ran
                                window.location.href = '/cart';
                              from a `done` callback, leaving the page.
           2026-09-02 (Wander) it now behaves like the two subscription cards:
                              add, then open the side drawer with its bundle
                              upsell slots. Dropping the `done` callback is the
                              whole change - addToCart's default tail already
                              clears busy and calls opener.click() on #tcdOpener,
                              which is the exact path #tlpAtc and the sticky bar
                              use. Nothing about the item changed: quantity 1,
                              no selling_plan, straight from the PLANS row.
         paint('once') stays: it marks the card selected before the add lands,
         and leaves the page in the right state if the fetch fails.
         NOTE the anchor is href="#", not href="/cart" - so the capture-phase
         interceptor in snippets/cart-background.liquid, which matches
         .cart-pill / a[href="/cart"] / a[href$="/cart"], does NOT fire on it.
         The preventDefault below is the only thing stopping the '#' jump, and
         this is the only handler that opens the drawer for this link. */
      var once = e.target.closest('[data-plan="once"]');
      if (once) {
        e.preventDefault();
        paint('once');
        addToCart('once', null);
        return;
      }

      if (atc && e.target.closest('#tlpAtc')) {
        e.preventDefault();
        /* 2026-09-02 (Wander): this stopPropagation fixes a DOUBLE ADD. Four
           listeners answer a click on #tlpAtc:
             1. snippets/cart-background.liquid - document, CAPTURE. Opens the
                drawer from the top via #tessHeaderCartOpener. It matches
                a[href="/cart"], and #tlpAtc is an <a href="/cart">.
             2. snippets/cart-open.liquid       - document, CAPTURE. Primes the
                entrance animation (.is-mounted + origin class).
             3. this handler                    - #tlp, bubble. Adds
                PLANS[current].qty, i.e. 3 for 90-Day, 1 for 30-Day.
             4. sections/cart-drawer.liquid     - document, bubble. ALSO POSTed
                /cart/add.js with a hardcoded quantity of 1.
           3 and 4 both hit /cart/add.js, so the cart received qty + 1: four
           units on the 90-Day plan, two on the 30-Day. Stopping propagation
           here suppresses 4 and nothing else - 1 and 2 are CAPTURE phase and
           have already run by the time this fires, so the drawer still mounts
           and still opens (and this handler opens it itself via opener.click()
           below). cart-drawer's #tlpAtc branch is deliberately LEFT IN PLACE as
           a fallback for when this file fails to load. */
        e.stopPropagation();
        addToCart(current, atc);
      }
    });

    if (sel) {
      sel.addEventListener('change', function () { paint(sel.value); });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(current, stickyBtn);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
